/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import { MdChevronRight } from 'react-icons/md';
import { BiMedal } from 'react-icons/bi';
import Link from 'next/link';
import { Divider } from 'semantic-ui-react';

type UseCase = 'bounce_blast' | 'default';

const defaultConfig = {
  description:
    'Unlock Early Payouts and more by hosting events with a Verified+ Organization. Schedule a quick call with Bounce to complete your verification.',
  benefits: (
    <div className="flex flex-col gap-1">
      <p className="text-base font-bold">The Benefits:</p>
      <p className="text-base font-normal">
        💰 Get paid faster for your events with <b>Early Payouts.</b>
      </p>
      <p className="text-base font-normal">
        📊 Access <b>advanced tools</b> for managing your events.
      </p>
      <p className="text-base font-normal">
        🕺 <b>Build trust</b> and attract more attendees.
      </p>
    </div>
  ),
  showAlreadyVerified: true
};

const modalConfigs = {
  default: defaultConfig,
  bounce_blast: {
    description:
      'Unlock Bounce Blasts and more by becoming a Verified+ Organization. Schedule a quick call with Bounce to complete your verification and start reaching your audience instantly.',
    benefits: defaultConfig.benefits,
    showAlreadyVerified: false
  }
};

interface GetVerifiedModalProps {
  open: boolean;
  onClose?: () => void;
  useCase?: UseCase;
}

const GetVerifiedModal = ({
  open,
  onClose,
  useCase = 'default'
}: GetVerifiedModalProps) => {
  const config = modalConfigs[useCase];

  return (
    <Modal
      visible={open}
      title="Verify Your Organization"
      icon={<BiMedal size={20} />}
      type={ModalType.VERY_SMALL}
      onClose={onClose}
    >
      <div className="flex flex-col pt-6 px-4">
        <p className="text-base font-normal">{config.description}</p>
        <br />
        {config.benefits}
        <br />
        <Link
          href="mailto:support@bouncedinc.com"
          className="flex flex-row justify-start w-full h-[126px] bg-linear-to-r from-blue-900 to-blue-600 rounded-[20px]"
        >
          <div className="flex w-1/3 h-full justify-center relative">
            <img
              src="/img/logos/ball_logo.svg"
              className="w-2/3 z-0 absolute top-[17%]"
            />
            <img
              src="/img/team/robbie_booking.png"
              className="w-[73%] z-20 self-end"
            />
          </div>
          <div className="flex flex-row w-2/3 h-full justify-center items-center">
            <div className="w-[90%] flex flex-col">
              <p className="text-white text-xl self-start">Contact Support</p>
              <p className="text-white text-lg font-light self-start">
                Email our support team
              </p>
            </div>
            <div className="w-[10%]">
              <p className="text-white text-2xl self-start">
                <MdChevronRight />
              </p>
            </div>
          </div>
        </Link>
        {config.showAlreadyVerified && (
          <>
            <br />
            <Divider />
            <br />
            <div className="w-full bg-gray-100 rounded-[20px] px-2 py-4">
              <p className="font-semibold">Already Verified?</p>
              <p className="text-gray-500 font-light">
                If your Organization is already Verified+, set it as the event
                host to access Early Payouts.
              </p>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default GetVerifiedModal;
